const PATH = "M848 1609 c-102 -24 -340 -230 -398 -345 -18 -36 -26 -44 -28 -29 -2 19 26 138 43 179 15 36 -56 -13 -130 -89 -113 -116 -185 -257 -188 -366 -2 -63 -8 -72 -24 -37 -17 38 -36 -60 -23 -118 6 -26 9 -48 7 -51 -2 -2 -21 15 -40 37 -36 39 -37 39 -43 16 -6 -26 12 -128 29 -161 5 -11 25 -37 44 -58 31 -35 33 -41 27 -85 -9 -72 10 -127 64 -181 26 -26 66 -58 89 -71 42 -23 73 -74 73 -119 0 -13 16 -25 59 -41 71 -26 105 -24 109 8 5 31 22 27 22 -5 0 -16 4 -33 8 -40 9 -14 184 -36 222 -28 17 4 30 16 37 35 14 37 29 38 37 5 8 -30 18 -31 112 -6 91 23 94 26 94 64 0 40 21 72 62 93 17 9 53 36 79 61 72 68 94 151 63 251 -6 19 0 25 50 48 30 14 64 36 75 50 25 32 47 132 56 254 l8 95 -48 -53 c-26 -28 -50 -52 -55 -52 -4 0 -10 31 -12 69 -6 78 -26 120 -103 214 -74 91 -88 143 -61 219 l13 36 -26 -9 c-70 -27 -108 -64 -150 -148 -12 -24 -24 -41 -26 -39 -11 11 -80 119 -98 153 -31 59 -31 181 1 224 12 17 19 31 15 30 -4 -1 -25 -5 -45 -10z m-316 -1059 c35 -12 69 -24 76 -26 18 -5 14 -65 -7 -100 -21 -35 -75 -64 -118 -64 -39 0 -112 39 -137 72 -27 37 -33 131 -13 181 l16 37 60 -38 c33 -22 88 -49 123 -62z m552 79 c21 -17 26 -29 26 -65 0 -102 -72 -184 -163 -184 -87 0 -147 47 -147 114 0 22 12 31 83 64 45 22 98 51 117 65 43 32 50 32 84 6z m-314 -275 c22 -57 16 -64 -55 -64 -38 0 -65 4 -65 10 0 6 7 26 14 45 14 32 19 35 56 35 34 0 42 -4 50 -26z";

/** Logo officiel War Legend, repris du front WLS. */
export function WlsLogo({ size = 44, title }: { size?: number; title?: string }) {
  const gradientId = "wls-logo-gradient";
  return (
    <svg
      viewBox="0 0 146 164"
      width={size}
      height={size * (164 / 146)}
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f34a53" />
          <stop offset="100%" stopColor="#cb3c6d" />
        </linearGradient>
      </defs>
      <g transform="translate(0, 164) scale(0.1, -0.1)" fill={`url(#${gradientId})`} stroke="none">
        <path d={PATH} />
      </g>
    </svg>
  );
}
